const o = "_button_jjcsp_1", s = "_tooltip_jjcsp_13", t = "_arrow_jjcsp_51", _ = "_close_jjcsp_59", c = "_isOver_jjcsp_75", j = "_yellow_jjcsp_83", l = "_white_jjcsp_86", e = "_md_jjcsp_89", n = "_lg_jjcsp_97", p = {
  button: o,
  tooltip: s,
  arrow: t,
  close: _,
  isOver: c,
  yellow: j,
  white: l,
  md: e,
  lg: n
};
export {
  t as arrow,
  o as button,
  _ as close,
  p as default,
  c as isOver,
  n as lg,
  e as md,
  s as tooltip,
  l as white,
  j as yellow
};
//# sourceMappingURL=tooltip.module.less.js.map
